import type { TableColFilter } from "~/components/table/col-filter";
import { fromEntries } from "~/tools/from-entries";
import { ImmutableMap } from "~/tools/immutable-map";
import { Impulse, useScoped } from "~/tools/impulse";
import { map } from "~/tools/map";
import { pipe } from "~/tools/pipe";
import type { Record } from "~/tools/record";
import { toArray } from "~/tools/to-array";
import { Tuple } from "~/tools/tuple";
import { usePermanent } from "~/tools/use-permanent";

import type { OverviewColumnFilter } from "../../common/openapi";

interface UseOverviewFilteringResult {
	filtering: Record<string, OverviewColumnFilter>;
	filters: Impulse<ImmutableMap<string, TableColFilter>>;
}

export function useOverviewTableFiltering(): UseOverviewFilteringResult {
	const filters = usePermanent(() => Impulse(ImmutableMap.empty<string, TableColFilter>()));

	const filtering = useScoped(
		(scope) => {
			const entries = filters.getValue(scope).entries();

			return pipe(
				toArray(entries),
				map(([columnId, { query }]): OverviewColumnFilter => ({ columnId, search: query })),
				map((entry) => Tuple(entry.columnId, entry)),
				fromEntries(),
			);
		},

		[filters],
	);

	return { filtering, filters };
}
